import memoize from 'memoizee';
import { contract } from '../../contract';
import getPricesForAssets from './getPricesForAssets';
import { sequentialPromiseMap } from '@/utils/Async'
import { contractAbis, balancer_ABI, balancer_address, ERC20_abi } from '@/constants/abis';

const getCurveRewards = memoize(async () => {
  const now = Date.now() / 1000;
  const statsAave = await (await fetch(`https://aave-api-v2.aave.com/data/markets-data/0xd05e3e715d945b59290df0ae8ef85c1bdb684744`)).json();

  const lpToken = new contract.web3.eth.Contract(ERC20_abi, contractAbis['aave'].token_address)
  const swap = new contract.web3.eth.Contract(contractAbis['aave'].swap_abi, contractAbis['aave'].swap_address)
  const wmaticRewards = new contract.web3.eth.Contract(contractAbis.aave.sCurveRewards_abi, contractAbis.aave.sCurveRewards_address)
  const paaveCurve = new contract.web3.eth.Contract(contractAbis.aave.swap_abi, contractAbis.aave.swap_address)

  let aaveApys = []
  await sequentialPromiseMap(contractAbis['aave'].underlying_coins, async (coinAddress) => {
    let coinData = statsAave.reserves.find(({ underlyingAsset }) => underlyingAsset === coinAddress);
    aaveApys.push(coinData.aIncentivesAPY)
  })
  const calls = [
    [contractAbis['aave'].swap_address, swap.methods.balances(0).encodeABI()],
    [contractAbis['aave'].swap_address, swap.methods.balances(1).encodeABI()],
    [contractAbis['aave'].swap_address, swap.methods.balances(2).encodeABI()],
    [contractAbis['aave'].token_address, lpToken.methods.totalSupply().encodeABI()],
    [contractAbis['aave'].token_address, lpToken.methods.balanceOf(contractAbis['aave'].gauge_address).encodeABI()],

  ]

  const aggcalls = await contract.multicall.methods.aggregate(calls).call();

  const decoded = aggcalls[1].map((hex) => contract.web3.eth.abi.decodeParameter('uint256', hex))
  let totalBalance = ((decoded[0] / contractAbis['aave'].coin_precisions[0]) + (decoded[1] / contractAbis['aave'].coin_precisions[1]) + (decoded[2] / contractAbis['aave'].coin_precisions[2]))
  let totalSupply = (decoded[3] / 10 ** 18)
  let stakedBalance = (decoded[4] / 10 ** 18)
  let averageApy = ((aaveApys[0] * (decoded[0] / contractAbis['aave'].coin_precisions[0])) + (aaveApys[1] * (decoded[1] / contractAbis['aave'].coin_precisions[1])) + (aaveApys[2] * (decoded[2] / contractAbis['aave'].coin_precisions[2])))
  let maticAPY = (averageApy * 100) / totalBalance * totalSupply / stakedBalance

  const prices = await getPricesForAssets(['matic-network', 'curve-dao-token']);
  const maticPrice = prices['matic-network'];
  const crvPrice = prices['curve-dao-token'];

  const timestampEndMaticRewards = 1624389721;
  const wmaticRewardsAmount = (
    timestampEndMaticRewards < now ?
      0 :
      (maticPrice * 12020000 * 6 / stakedBalance * 100)
  );

  return {
    WMATIC: {
      rewards: maticAPY + wmaticRewardsAmount,
      price: maticPrice,
    },
    CRV3POOL: {
      rewards: 0,
      price: crvPrice,
    }
  };
}, {
  promise: true,
  maxAge: 10 * 60 * 0, // 10m
});

export default getCurveRewards;
